/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Save_Check_FailedInputs */



/**
* | output |
* | --- |
* | "The server-side check of the endpoint failed. The checklist above shows why." |
*
* @param {Private_Models_Save_Check_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_save_check_failed = /** @type {((inputs?: Private_Models_Save_Check_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Save_Check_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die serverseitige Prüfung des Endpunkts ist fehlgeschlagen. Die Checkliste oben zeigt den Grund.")
	return /** @type {LocalizedString} */ ("The server-side check of the endpoint failed. The checklist above shows why.")
});